import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import './light-mode.css'

/* 明亮 Mode（Captain 2026-09-12）：預設暗黑；localStorage aibot_theme=light 先切——render 前套用避免閃屏 */
try {
  if (localStorage.getItem('aibot_theme') === 'light') document.documentElement.classList.add('light')
} catch { /* private mode 等 */ }

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* basename：app 永遠服務於 /admin/（gateway 剝前綴代理）——冇 basename 嘅話側欄導航會走出去 /referrals 等裸路徑，refresh／直接輸入網址就跌出 admin（2026-09-08 實錄） */}
    <BrowserRouter basename="/admin">
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
